import React from "react"
import { Form } from "formik"
import { Button, Flex } from "theme-ui"
import CheckboxInput from "@fields/CheckboxInput"
import EmailInput from "@fields/EmailInput"
import PasswordInput from "@fields/PasswordInput"
import TextInput from "@fields/TextInput"

export default ({ dirty, isSubmitting, isValid, values, ...props }) => (
  <Flex as={Form} sx={{ flexWrap: `wrap` }}>
    <TextInput name="firstName" placeholder="Imię" />
    <TextInput name="lastName" placeholder="Nazwisko" />
    <EmailInput name="email" placeholder="Email" />
    <PasswordInput name="password" placeholder="Hasło" />
    <CheckboxInput
      name="acceptPrivacyPolicy"
      label="Akceptuje Politykę Prywatności strony dworld.pl *"
      mt="1rem"
      sx={{ flex: "1 0 100%" }}
    />

    <CheckboxInput
      name="subscribeToNewsletter"
      label="Zapisz się do newslettera"
      mt="1rem"
      sx={{ flex: "1 0 100%" }}
    />

    <Button
      disabled={!dirty || !isValid || isSubmitting}
      type="submit"
      variant="submit"
    >
      Zarejestruj się
    </Button>
  </Flex>
)
